import { getAccessToken } from '../../services/authService'
async function call(path, body) {
  const token = getAccessToken()
  if (!token) throw new Error('Please sign in again.')
  const response = await fetch(`${process.env.REACT_APP_DEV_API}${path}`, {
    method: body ? 'POST' : 'GET', headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
    ...(body ? { body: JSON.stringify(body) } : {}),
  })
  const json = await response.json().catch(() => ({}))
  if (!response.ok || !json.data) throw new Error(json.message || 'Credit purchases are unavailable for this account.')
  return json.data
}
export const creditPackages = () => call('/payment/credits')
export const purchaseCredits = (amount, requestId) => call('/payment/credits/checkout', { amount, requestId })
export const creditPurchaseHistory = before => call(`/payment/credits/history${before ? `?before=${encodeURIComponent(before)}` : ''}`)
export const confirmCreditPurchase = reference => call('/payment/credits/confirm', { reference })